import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import AppSection from './AppSection';
import { groupRolesByApp } from './userGroupRolesUtils';
import {
  UserGroupContainer,
  GroupHeader,
  GroupLabel,
  GroupName,
  AppsContainer,
  EmptyState,
} from './styles';

const UserGroupCard = ({ userGroup }) => {
  const { t } = useTranslation();

  const groupedApps = groupRolesByApp(userGroup);
  const hasContent = groupedApps.length > 0;

  return (
    <UserGroupContainer>
      <GroupHeader>
        <GroupLabel>User group:</GroupLabel>
        <GroupName>{userGroup.name}</GroupName>
      </GroupHeader>
      {hasContent ? (
        <AppsContainer>
          {groupedApps.map((app, index) => (
            <AppSection
              key={`${app.installationTag}_${app.communityTag}_${index}`}
              installationTag={app.installationTag}
              installationName={app.installationName}
              communityTag={app.communityTag}
              features={app.features}
            />
          ))}
        </AppsContainer>
      ) : (
        <EmptyState>{t('noRolesInUserGroup')}</EmptyState>
      )}
    </UserGroupContainer>
  );
};

UserGroupCard.propTypes = {
  userGroup: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    apps: PropTypes.arrayOf(
      PropTypes.shape({
        communityTag: PropTypes.string,
        installationTag: PropTypes.string,
        features: PropTypes.array,
      })
    ),
  }).isRequired,
};

export default UserGroupCard;
